import {AfterViewInit, EventEmitter, Output, Input, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
  
@Component({
  selector: 'channels-header', 
  templateUrl: './channels-header.component.html',
  styleUrls: ['./channels-header.component.scss'],
  
})
export class ChannelsHeaderComponent implements OnInit, OnDestroy, AfterViewInit{
 
  @Input() opacity: boolean = false
  @Input() searchBar: boolean = false
  @Output() onSearch = new EventEmitter<any>();
  @Output() onCancelSearch = new EventEmitter<boolean>();
  searchText: string = ''
  prevSearch: string|boolean = ''
  searchMode: boolean = false


  constructor(){  }
 
  search(){

	this.searchText = this.searchText.trim()


	if(this.prevSearch !== this.searchText){

	this.onSearch.emit(this.searchText)
	this.searchMode = this.searchText ? true : false
	this.prevSearch = this.searchText
	}

  }

  cancelSearch(){

	this.prevSearch = false
	this.searchMode = false
	this.searchText = ''
	this.onCancelSearch.emit()
  }

   ngOnInit() { 
  
  }


 


  
   ngAfterViewInit() {
 
   }
 
   ngOnDestroy() {
   
   }
 
   

 
  
}
